import React from 'react';

function Testimonials() {
  return (
    <section className="feat-sec section-padding main-bg">
      <div className="container">
        <div className="row xlg-marg">
          <div className="col-lg-6">
            <div className="row sm-marg">
              <div className="col-md-4">
                <div className="item box1 text-center mb-10">
                  <span className="icon-img-40 mb-15">
                    <img src="/landing-preview/img/feat/1.svg" alt="" />
                  </span>
                  <h6>Elementor</h6>
                  <span className="p-color sub-title mt-5">
                    SUPPORTED PLUGIN
                  </span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="item box2 text-center mb-10">
                  <span className="icon-img-40 mb-15">
                    <img src="/landing-preview/img/feat/2.svg" alt="" />
                  </span>
                  <h6>Elementor</h6>
                  <span className="p-color sub-title mt-5">
                    SUPPORTED PLUGIN
                  </span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="item box3 text-center mb-10">
                  <span className="icon-img-40 mb-15">
                    <img src="/landing-preview/img/feat/3.svg" alt="" />
                  </span>
                  <h6>Elementor</h6>
                  <span className="p-color sub-title mt-5">
                    SUPPORTED PLUGIN
                  </span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="item box4 text-center mb-10">
                  <span className="icon-img-40 mb-15">
                    <img src="/landing-preview/img/feat/4.svg" alt="" />
                  </span>
                  <h6>Elementor</h6>
                  <span className="p-color sub-title mt-5">
                    SUPPORTED PLUGIN
                  </span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="item box5 text-center mb-10">
                  <span className="icon-img-40 mb-15">
                    <img src="/landing-preview/img/feat/5.svg" alt="" />
                  </span>
                  <h6>Elementor</h6>
                  <span className="p-color sub-title mt-5">
                    SUPPORTED PLUGIN
                  </span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="item box6 text-center mb-10">
                  <span className="icon-img-40 mb-15">
                    <img src="/landing-preview/img/feat/6.svg" alt="" />
                  </span>
                  <h6>Elementor</h6>
                  <span className="p-color sub-title mt-5">
                    SUPPORTED PLUGIN
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 valign">
            <div className="cont">
              <h6 className="sub-title main-color mb-15">POWERFUL PLUGINS</h6>
              <h2 className="mb-15">
                $100-worth of <br />
                <span className="fw-200">Premium</span>
                <span className="fw-200">Plugins</span> for Free!
              </h2>
              <p>
                With our theme, you get a bundle of premium plugins to help you
                create exactly what you want. Get the best experience with less
                effort.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
